import { render, staticRenderFns } from "./buylist.vue?vue&type=template&id=5d6b7e88&scoped=true"
import script from "./buylist.vue?vue&type=script&lang=js"
export * from "./buylist.vue?vue&type=script&lang=js"
import style0 from "./buylist.vue?vue&type=style&index=0&id=5d6b7e88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6b7e88",
  null
  
)

export default component.exports